<template>
  <div class="account-balance__tabs">
    <div class="account-balance__tabs-body">
      <button
        v-for="(tabItem, tabItemIndex) in tabs"
        class="account-balance__tabs-body-item base-btn"
        :key="tabItemIndex"
        :class="{ _active: tab === tabItemIndex }"
        @click="$emit('change', tabItemIndex)"
      >
        <span class="base-btn__text">
          {{ tabItem }}
        </span>
      </button>
    </div>

    <div class="account-balance__tabs-sidebar">
      <slot name="sidebar"/>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'AccountBalanceTabs',

    props: {
      tabs: {
        type: Array,
        default: () => []
      },
      tab: {
        type: Number,
        default: 0
      }
    }
  };
</script>
